import React from "react";
import {Component, useState } from "react";
import { setLoadingPage, setErrorMessage, setHeaderVisible} from "../../../reducers/actions";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import moment from "moment";
import Layout from "../../../Layout/layout";
import axios from "axios";
import { apiHost, encodeQueryData } from "../../../api/apiClient";
import IButtonReportTable from "./iButtonRptTable";
import {
    FormControl,
    Dropdown,
    Button,
  } from "react-bootstrap"; 
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import Calendar from "react-calendar/dist/umd/Calendar";

class IButtonData extends Component {
    constructor(props) {
        super(props);
        this.state = {
          filter: false,
          date: new Date(),
          iButtonData:[],
          serialNo: "",
          name:"",
          IButtonDetails:[],
          customerId : "",
          customerName: "",
          calendarShow: false,
          dataPlaceholder: moment().format("MMMM YYYY"),
          calendarSelectedDate: new Date(),
          startDate: moment().clone().startOf('month').format("YYYY-MM-DD"),
          endDate : moment().clone().endOf('month').format("YYYY-MM-DD"),
          ReportDate: moment().format("YYYY-MM-DD"),
          LastRefreshDate:  null
        };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
    this.setWrapperRef = this.setWrapperRef.bind(this);
      }
      

    async componentDidMount(){
      var urlAll = "";
      let query = encodeQueryData(this.setIbuttonQueryObject());
      urlAll = `${apiHost}/api/IButton/IButtonDetails?${query}`;
      this.getIbutton(urlAll);
    };

    handleWindow = () => {
      this.props.setHeaderVisibleAction(!this.props.headerHide);
    };

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({ calendarShow: false });
      }
    }

    setWrapperRef(node) {
      this.wrapperRef = node;
    };

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
      
    setIbuttonQueryObject = () => {
      let data = {};
      data.SearchString = this.searchText;
      data.customerId = this.customerId;
      data.PageSize = this.pageSize;
      data.PageNumber = this.pageKey;
      data.SortDirection = this.sortDirection;
      data.SortString = this.sortString;
      data.FetchAll = true;
      return data;
    };

    getIbutton = async (url) => {
      this.props.setLoadingPageAction(true);    
        try {
          let ibuttonList = await axios.get(url, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          console.log("list", ibuttonList);
          this.setState({
            IButtonDetails: ibuttonList.data,
          });    
          this.props.setLoadingPageAction(false);
        }
        catch (e) {
          if (e.response.status == "401") {
            this.props.history.push("/login");
          }else{
            this.props.setErrorMessageAction(`${e}`)    
          }
          this.props.setLoadingPageAction(false);    
          console.log(`😱 Axios request failed: ${e}`);
      }
    };
    
    handleGroupDropDown = (customerName, serialNo, name, id,customerId) => {
      this.setState({
      customerName: customerName,
      serialNo: serialNo,
      name: name,
      customerId:customerId
      });
    };

    calendarFunction = () => {
      this.setState({
        calendarShow: !this.state.calendarShow,
      });
    };

    onChangeDate = (date) => {
      const momentDate = moment(date); 
      this.setState({
          calendarSelectedDate: date,
          ReportDate: momentDate.format("YYYY-MM-DD"),
          startDate: momentDate.clone().startOf('month').format("YYYY-MM-DD"),
          endDate: momentDate.clone().endOf('month').format("YYYY-MM-DD"),
          dataPlaceholder: momentDate.format("MMMM YYYY"),
          calendarShow: false,
      });
    };
    
    handleCreateReport = async () => {
      
      this.setState({
        iButtonData:[]
      });
      this.props.setLoadingPageAction(true);
      try {
        let iButtonData = await axios.post(
        `${apiHost}/api/Report/IbuttonReport`,
            {
              serialNo: this.state.serialNo,
              SearchDate:this.state.startDate,
              endDate: this.state.endDate,                       
              Timezone: localStorage.getItem("timeZoneID"),
              customerId:this.state.customerId,
              UseFiltering: false,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        this.props.setLoadingPageAction(false);
        this.setState({ 
          iButtonData: iButtonData.data,
        });
        this.props.setLoadingPageAction(false);
      } 
      catch (e) {
        if (e && e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);  
        console.log(`😱 Axios request failed: ${e}`);
      }
    };
  
    render() {
      const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <button
          href=""
          className="dropDownSearch"
          ref={ref}
          onClick={(e) => {
            e.preventDefault();
            onClick(e);
          }}
        >
          {children}
          <i className="fa fa-address-card-o" />
        </button>
      ));

      const calendarReport = this.state.calendarShow ? (
        <div
          ref={this.setWrapperRef}
          className="ParentCalender"
          style={{ position: "relative", zIndex: 100 }}
        >
          <div className="CalendarContainer" style={{ position: "absolute" }}>
            <Calendar
              maxDate={new Date()}
              onChange={this.onChangeDate}
              value={this.state.calendarSelectedDate}
            />
          </div>
        </div>
      ) : (
        ""
      );
  
      const CustomMenu = React.forwardRef(
        ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
          const [value, setValue] = useState("");
  
          return (
            <div
              ref={ref}
              style={style}
              className={className}
              aria-labelledby={labeledBy}
            >
              <FormControl
                autoFocus
                className="mx-3 my-2 w-auto"
                placeholder="Type to filter..."
                onChange={(e) => setValue(e.target.value)}
                value={value}
              />
              <ul className="list-unstyled">
                {React.Children.toArray(children).filter(
                  (child) =>
                    !value || child.props.children.toLowerCase().includes(value)
                )}
              </ul>
            </div>
          );
        }
      );
  
      return (
        <Layout>
          <Helmet>
            <title>iButton Monthly Report</title>
          </Helmet>
          <div className="contentBody">
            <div
              className={
                !this.props.headerHide
                  ? `contentWrapper contentWrapperSmoothRelease`
                  : `contentWrapper contentWrapperSmooth`
              }
            >
              <div className="headingContainer">
                <h2 className="mainHeading">
                iButton Monthly Report <span>v1.8.0</span>
                </h2>
                <i
                  className={
                    this.props.headerHide
                      ? `fa fa-window-restore`
                      : `fa fa-window-maximize`
                  }
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup">
                  <div className="inputElement">
                    <Dropdown>
                      <Dropdown.Toggle
                          as={CustomToggle}
                          id="dropdown-custom-components"
                      >
                          {this.state.customerName != "" ? (
                          <span>{this.state.name != "" ?`${this.state.customerName} - ${this.state.name}(${this.state.serialNo})`:`${this.state.customerName} - ${this.state.serialNo}`}</span>
                          ) : (
                          "Select Customer"
                          )}
                      </Dropdown.Toggle>

                      <Dropdown.Menu as={CustomMenu}>
                          {this.state.IButtonDetails.map((item, index) => {
                          return (
                              <Dropdown.Item
                              onClick={() =>
                                  this.handleGroupDropDown(
                                  item.customerName,
                                  item.serialNo,
                                  item.name,
                                  item.id,
                                  item.customerId
                                  )
                              }
                              >
                              {item.name != "" ?`${item.customerName} - ${item.name}(${item.serialNo})`:`${item.customerName} - ${item.serialNo}`}

                              </Dropdown.Item>
                          );
                          })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="inputElement">
                    <ReportButtonGroup
                      function={this.calendarFunction}
                      dropDown={calendarReport}
                      placeholder={this.state.dataPlaceholder}
                      icon="fa-calendar"
                    />
                  </div>
                  <div className="inputElement">
                    {this.state.customerName != "" ? (
                      <Button
                        variant="outline-secondary"
                        onClick={this.handleCreateReport}
                        size="sm"
                      >
                        Create Report
                      </Button>
                    ) : (
                      <Button
                        variant="outline-secondary"
                        onClick={this.handleCreateReport}
                        size="sm"
                        disabled
                      >
                        Create Report
                      </Button>
                    )}
                  </div>
                </div>
                <IButtonReportTable iButtonData={this.state.iButtonData}
                assetCustomerName={this.state.customerName}
                />
            </div>
          </div>
        </Layout>
      );
    }
  }     
const mapStateToProps = (state) => ({
    headerHide: state.headerHide,
  });
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible
};
  
export default connect(mapStateToProps, mapDispatchToProps)(IButtonData);
  
